import { render, staticRenderFns } from "./BarrelIcon.vue?vue&type=template&id=dd3f34a4&"
import script from "./BarrelIcon.vue?vue&type=script&lang=js&"
export * from "./BarrelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports